import { Component, Element, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-iws-sf-status-tag",
    styleUrl: "sf-status-tag.scss",
    shadow: true,
})
export class SfStatusTag {
    /** The host element of the component */
    @Element() host: HTMLUxIwsSfStatusTagElement;

    /** Status of the tag, which determines its color. */
    @Prop({ reflect: true }) status:
        | "info"
        | "success"
        | "warning"
        | "error"
        | "disabled" = "info";

    render() {
        return (
            <Host>
                <ux-tag>
                    <slot />
                </ux-tag>
            </Host>
        );
    }
}
